import { render, staticRenderFns } from "./table-attachment.vue?vue&type=template&id=6adc60c4"
import script from "./table-attachment.vue?vue&type=script&lang=ts"
export * from "./table-attachment.vue?vue&type=script&lang=ts"
import style0 from "./table-attachment.vue?vue&type=style&index=0&id=6adc60c4&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6adc60c4')) {
      api.createRecord('6adc60c4', component.options)
    } else {
      api.reload('6adc60c4', component.options)
    }
    module.hot.accept("./table-attachment.vue?vue&type=template&id=6adc60c4", function () {
      api.rerender('6adc60c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/table/table-attachment.vue"
export default component.exports